import React from 'react'
import { BtnContainer, ButtonPrimary, ButtonSecondary } from './styled.components'
import { Loader } from 'Components/V1/Loader/Loader'

const FooterBtns = ({handleCancel,handleSubmit,loader}:any) => {
  return (
    <BtnContainer>
        {loader ? (
          <>
            <Loader />
          </>
        ) : (
          <>
            <ButtonSecondary variant="outlined" onClick={handleCancel}>
              Cancelar
            </ButtonSecondary>
            <ButtonPrimary variant="contained" onClick={handleSubmit}>
              Guardar
            </ButtonPrimary>
          </>
        )}
      </BtnContainer>
  )
}

export default FooterBtns